import { CALL_INTAKE_V2_API } from 'middleware/intakeV2Api';

import {
  GET_HHG_WEIGHT_IMPORT_TEMPLATES_FAILURE,
  GET_HHG_WEIGHT_IMPORT_TEMPLATES_REQUEST,
  GET_HHG_WEIGHT_IMPORT_TEMPLATES_SUCCESS,
  GET_HHG_WEIGHT_IMPORT_TEMPLATE_FAILURE,
  GET_HHG_WEIGHT_IMPORT_TEMPLATE_REQUEST,
  GET_HHG_WEIGHT_IMPORT_TEMPLATE_SUCCESS,
  POST_HHG_WEIGHT_IMPORT_TEMPLATE_DRYRUN_FAILURE,
  POST_HHG_WEIGHT_IMPORT_TEMPLATE_DRYRUN_REQUEST,
  POST_HHG_WEIGHT_IMPORT_TEMPLATE_DRYRUN_SUCCESS,
  POST_HHG_WEIGHT_IMPORT_TEMPLATE_FAILURE,
  POST_HHG_WEIGHT_IMPORT_TEMPLATE_REQUEST,
  POST_HHG_WEIGHT_IMPORT_TEMPLATE_SUBMIT_FAILURE,
  POST_HHG_WEIGHT_IMPORT_TEMPLATE_SUBMIT_REQUEST,
  POST_HHG_WEIGHT_IMPORT_TEMPLATE_SUBMIT_SUCCESS,
  POST_HHG_WEIGHT_IMPORT_TEMPLATE_SUCCESS,
  PUT_HHG_WEIGHT_IMPORT_TEMPLATE_FAILURE,
  PUT_HHG_WEIGHT_IMPORT_TEMPLATE_REQUEST,
  PUT_HHG_WEIGHT_IMPORT_TEMPLATE_SUCCESS,
} from './importHhgWeights.types';

export const getHhgWeightImportTemplates = () => ({
  [CALL_INTAKE_V2_API]: {
    types: [GET_HHG_WEIGHT_IMPORT_TEMPLATES_REQUEST, GET_HHG_WEIGHT_IMPORT_TEMPLATES_SUCCESS, GET_HHG_WEIGHT_IMPORT_TEMPLATES_FAILURE],
    authenticated: true,
    endpoint: 'api/ImportTool/HhgWeights',
    method: 'GET',
  },
});

export const getHhgWeightImportTemplate = templateId => ({
  [CALL_INTAKE_V2_API]: {
    types: [GET_HHG_WEIGHT_IMPORT_TEMPLATE_REQUEST, GET_HHG_WEIGHT_IMPORT_TEMPLATE_SUCCESS, GET_HHG_WEIGHT_IMPORT_TEMPLATE_FAILURE],
    authenticated: true,
    endpoint: `api/ImportTool/HhgWeights/${templateId}`,
    method: 'GET',
  },
});

export const postHhgWeightImportTemplate = template => ({
  [CALL_INTAKE_V2_API]: {
    types: [POST_HHG_WEIGHT_IMPORT_TEMPLATE_REQUEST, POST_HHG_WEIGHT_IMPORT_TEMPLATE_SUCCESS, POST_HHG_WEIGHT_IMPORT_TEMPLATE_FAILURE],
    authenticated: true,
    endpoint: 'api/ImportTool/HhgWeights',
    method: 'POST',
    payload: template,
  },
});

export const putHhgWeightImportTemplate = (templateId, template) => ({
  [CALL_INTAKE_V2_API]: {
    types: [PUT_HHG_WEIGHT_IMPORT_TEMPLATE_REQUEST, PUT_HHG_WEIGHT_IMPORT_TEMPLATE_SUCCESS, PUT_HHG_WEIGHT_IMPORT_TEMPLATE_FAILURE],
    authenticated: true,
    endpoint: `api/ImportTool/HhgWeights/${templateId}`,
    method: 'PUT',
    payload: template,
  },
});

export const uploadHhgWeightImportTemplateFile = (templateId, file) => {
  const payload = new FormData();
  payload.append('file', file, file.name);

  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_HHG_WEIGHT_IMPORT_TEMPLATE_DRYRUN_REQUEST, POST_HHG_WEIGHT_IMPORT_TEMPLATE_DRYRUN_SUCCESS, POST_HHG_WEIGHT_IMPORT_TEMPLATE_DRYRUN_FAILURE],
      authenticated: true,
      endpoint: `api/ImportTool/HhgWeights/${templateId}/DryRun`,
      method: 'POST',
      payload,
    },
  };
};

export const submitHhgWeightImportTemplateFile = (templateId, file) => {
  const payload = new FormData();
  payload.append('file', file, file.name);

  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_HHG_WEIGHT_IMPORT_TEMPLATE_SUBMIT_REQUEST, POST_HHG_WEIGHT_IMPORT_TEMPLATE_SUBMIT_SUCCESS, POST_HHG_WEIGHT_IMPORT_TEMPLATE_SUBMIT_FAILURE],
      authenticated: true,
      endpoint: `api/ImportTool/HhgWeights/${templateId}/Submit`,
      method: 'POST',
      payload,
    },
  };
};
